(function () {
  'use strict';

  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }

  /* Double-tap guard for proxy buttons that forward to the real Kaching ATC: skip while an add is in flight or in
     its post-add cooldown (SlimmyKachingGuard.busy); without guarded forms fall back to a 1.2 s local cooldown. */
  var lastProxyAt = 0;
  function purchaseBusy() {
    var g = window.SlimmyKachingGuard;
    if (g && typeof g.busy === 'function' && g.contexts && g.contexts.length) return g.busy();
    return Date.now() - lastProxyAt < 1200;
  }

  /* ---------- Before/After sliders ---------- */
  function initBA(root) {
    var wrap = qs('[data-smp-ba]', root);
    if (!wrap || wrap.getAttribute('data-smp-ba-ready')) return;
    wrap.setAttribute('data-smp-ba-ready', '1');
    var after = qs('[data-smp-ba-after], .smp-ba__after', wrap);
    var handle = qs('[data-smp-ba-handle]', wrap);
    var range = qs('[data-smp-ba-range]', wrap);
    if (!after || !handle) return;
    var pos = 50;
    function set(p) {
      pos = Math.max(0, Math.min(100, p));
      after.style.clipPath = 'inset(0 0 0 ' + pos + '%)';
      handle.style.left = pos + '%';
      if (range) range.value = String(Math.round(pos));
      wrap.setAttribute('aria-valuenow', String(Math.round(pos)));
    }
    function fromEvent(e) {
      var pt = e.touches && e.touches[0] ? e.touches[0] : e;
      var rect = wrap.getBoundingClientRect();
      set(((pt.clientX - rect.left) / rect.width) * 100);
    }
    var drag = false;
    function start(e) { drag = true; fromEvent(e); if (e.cancelable) e.preventDefault(); }
    function move(e) { if (!drag) return; fromEvent(e); if (e.cancelable) e.preventDefault(); }
    function end() { drag = false; }
    wrap.addEventListener('pointerdown', function (e) {
      try { wrap.setPointerCapture(e.pointerId); } catch (_) {}
      start(e);
    });
    wrap.addEventListener('pointermove', move);
    wrap.addEventListener('pointerup', end);
    wrap.addEventListener('pointercancel', end);
    wrap.addEventListener('touchstart', start, { passive: false });
    wrap.addEventListener('touchmove', move, { passive: false });
    wrap.addEventListener('touchend', end);
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); set(pos - 3); }
      if (e.key === 'ArrowRight') { e.preventDefault(); set(pos + 3); }
      if (e.key === 'Home') { e.preventDefault(); set(0); }
      if (e.key === 'End') { e.preventDefault(); set(100); }
    });
    if (range) range.addEventListener('input', function () { set(Number(range.value)); });
    set(50);
  }

  function initEduBA(root) {
    var wrap = qs('[data-smp-edu-ba]', root);
    if (!wrap || wrap.getAttribute('data-smp-edu-ba-ready')) return;
    wrap.setAttribute('data-smp-edu-ba-ready', '1');
    /* Overlay = Day 1 (more) clipped from left; base = Week 12 (less). */
    var day1 = qs('.smp-edu__ba-img--more', wrap);
    var handle = qs('[data-smp-edu-ba-handle]', wrap);
    if (!day1 || !handle) return;
    var pos = 50;
    function set(p) {
      pos = Math.max(0, Math.min(100, p));
      day1.style.clipPath = 'inset(0 ' + (100 - pos) + '% 0 0)';
      handle.style.left = pos + '%';
      wrap.setAttribute('aria-valuenow', String(Math.round(pos)));
    }
    function fromEvent(e) {
      var pt = e.touches && e.touches[0] ? e.touches[0] : e;
      var rect = wrap.getBoundingClientRect();
      set(((pt.clientX - rect.left) / rect.width) * 100);
    }
    var drag = false;
    function start(e) { drag = true; fromEvent(e); if (e.cancelable) e.preventDefault(); }
    function move(e) { if (!drag) return; fromEvent(e); if (e.cancelable) e.preventDefault(); }
    function end() { drag = false; }
    wrap.addEventListener('pointerdown', function (e) {
      try { wrap.setPointerCapture(e.pointerId); } catch (_) {}
      start(e);
    });
    wrap.addEventListener('pointermove', move);
    wrap.addEventListener('pointerup', end);
    wrap.addEventListener('pointercancel', end);
    wrap.addEventListener('touchstart', start, { passive: false });
    wrap.addEventListener('touchmove', move, { passive: false });
    wrap.addEventListener('touchend', end);
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); set(pos - 3); }
      if (e.key === 'ArrowRight') { e.preventDefault(); set(pos + 3); }
    });
    wrap._smpEduBaSet = set;
    set(50);
  }

  /* ---------- Tabs / accordions ---------- */
  function initBots(root) {
    var tabs = qsa('[data-smp-bot-tab]', root);
    var panels = qsa('[data-smp-bot-panel]', root);
    if (!tabs.length) return;
    tabs.forEach(function (tab) {
      if (tab.getAttribute('data-smp-bound')) return;
      tab.setAttribute('data-smp-bound', '1');
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-smp-bot-tab');
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-smp-bot-panel') !== id; });
      });
    });
  }

  function readEduConcernConfig(box) {
    var el = qs('[data-smp-edu-concerns]', box);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function applyEduCompare(box, cfg, concern, label) {
    var defaults = (cfg && cfg.defaults) || {};
    var hasConcern = !!concern;
    var hasPair = !!(concern && (concern.more || concern.less));
    /* Never paint section Puffiness defaults onto another concern tab. */
    var moreUrl = hasPair ? (concern.more || null) : (!hasConcern ? defaults.more : null);
    var lessUrl = hasPair ? (concern.less || null) : (!hasConcern ? defaults.less : null);
    var lab = (label || (concern && concern.label) || 'Puffiness').toUpperCase();
    var heading;
    if (concern && concern.heading) {
      heading = concern.heading;
    } else if (hasConcern) {
      heading = 'DAY 1 VS WEEK 12 — ' + lab;
    } else {
      heading = defaults.heading || ('DAY 1 VS WEEK 12 — ' + lab);
    }
    var hEl = qs('[data-smp-edu-compare-heading]', box);
    if (hEl && heading) hEl.textContent = heading;
    var wrap = qs('[data-smp-edu-ba]', box);
    var moreImg = wrap ? qs('.smp-edu__ba-img--more', wrap) : null;
    var lessImg = wrap ? qs('.smp-edu__ba-img--less', wrap) : null;
    if (moreImg) {
      if (moreUrl) {
        moreImg.src = moreUrl;
        moreImg.srcset = '';
        moreImg.alt = 'Day 1';
        moreImg.hidden = false;
      } else if (hasConcern && !hasPair) {
        moreImg.removeAttribute('src');
        moreImg.srcset = '';
        moreImg.alt = '';
        moreImg.hidden = true;
      }
    }
    if (lessImg) {
      if (lessUrl) {
        lessImg.src = lessUrl;
        lessImg.srcset = '';
        lessImg.alt = 'Week 12';
        lessImg.hidden = false;
      } else if (hasConcern && !hasPair) {
        lessImg.removeAttribute('src');
        lessImg.srcset = '';
        lessImg.alt = '';
        lessImg.hidden = true;
      }
    }
    if (wrap) {
      wrap.classList.toggle('is-empty', !!(hasConcern && !hasPair));
      /* Per-pair aspect: ankles/chin 768×1024, hands/rings 652×1205, waist/love-handles 656×1199, legs/heaviness 656×1199, fog/brain-fog 585×1343, exhaust/exhaustion 656×1199; default puffiness CSS 687/1145. */
      var mk = String((concern && concern.markers) || '').toLowerCase();
      if (mk.indexOf('ankles') !== -1) {
        wrap.style.aspectRatio = '768 / 1024';
        wrap.setAttribute('data-smp-edu-aspect', 'ankles');
      } else if (mk.indexOf('hands') !== -1) {
        wrap.style.aspectRatio = '652 / 1205';
        wrap.setAttribute('data-smp-edu-aspect', 'hands');
      } else if (mk.indexOf('waist') !== -1) {
        wrap.style.aspectRatio = '656 / 1199';
        wrap.setAttribute('data-smp-edu-aspect', 'waist');
      } else if (mk.indexOf('legs') !== -1) {
        wrap.style.aspectRatio = '656 / 1199';
        wrap.setAttribute('data-smp-edu-aspect', 'legs');
      } else if (mk.indexOf('fog') !== -1) {
        wrap.style.aspectRatio = '585 / 1343';
        wrap.setAttribute('data-smp-edu-aspect', 'fog');
      } else if (mk.indexOf('exhaust') !== -1) {
        wrap.style.aspectRatio = '656 / 1199';
        wrap.setAttribute('data-smp-edu-aspect', 'exhaust');
      } else if (mk.indexOf('chin') !== -1) {
        wrap.style.aspectRatio = '768 / 1024';
        wrap.setAttribute('data-smp-edu-aspect', 'chin');
      } else {
        wrap.style.aspectRatio = '';
        wrap.removeAttribute('data-smp-edu-aspect');
      }
      wrap.setAttribute('aria-label', heading || 'Before and after comparison');
      if (typeof wrap._smpEduBaSet === 'function') wrap._smpEduBaSet(50);
      else {
        if (moreImg) moreImg.style.clipPath = 'inset(0 50% 0 0)';
        var handle = qs('[data-smp-edu-ba-handle]', wrap);
        if (handle) handle.style.left = '50%';
        wrap.setAttribute('aria-valuenow', '50');
      }
    }
  }


  /* Body highlight dots — % of mannequin frame (object-fit contain) */
  var SMP_EDU_MARKER_COORDS = {
    face: [{ x: 50, y: 9.5 }],
    abdomen: [{ x: 50, y: 40 }],
    thighs: [{ x: 39, y: 60 }, { x: 61, y: 60 }],
    ankles: [{ x: 43, y: 86.5 }, { x: 57, y: 86.5 }],
    hands: [{ x: 22, y: 48 }, { x: 78, y: 48 }],
    waist: [{ x: 38, y: 46 }, { x: 62, y: 46 }],
    legs: [{ x: 42, y: 72 }, { x: 58, y: 72 }],
    chin: [{ x: 50, y: 15 }],
    energy: [{ x: 50, y: 9.5 }],
    exhaust: [{ x: 50, y: 9.5 }],
    fog: [{ x: 50, y: 9.5 }]
  };

  function resolveEduMarkerKeys(cfg, concern, label) {
    var raw = (concern && concern.markers) || '';
    if (!raw && cfg && cfg.markerFallback) {
      var key = String(label || (concern && concern.label) || '').toLowerCase().trim();
      raw = cfg.markerFallback[key] || '';
    }
    if (!raw && cfg && cfg.defaults) raw = cfg.defaults.markers || '';
    return String(raw)
      .split(',')
      .map(function (s) { return s.trim().toLowerCase(); })
      .filter(Boolean);
  }

  function applyEduMarkers(box, cfg, concern, label) {
    var layer = qs('[data-smp-edu-markers]', box);
    if (!layer) return;
    while (layer.firstChild) layer.removeChild(layer.firstChild);
    var keys = resolveEduMarkerKeys(cfg, concern, label);
    keys.forEach(function (k) {
      var pts = SMP_EDU_MARKER_COORDS[k];
      if (!pts || !pts.length) return;
      pts.forEach(function (pt) {
        var d = document.createElement('span');
        d.className = 'smp-edu__dot is-on';
        d.style.left = pt.x + '%';
        d.style.top = pt.y + '%';
        d.setAttribute('data-marker', k);
        layer.appendChild(d);
      });
    });
  }

  function initConcernTabs(root) {
    var box = qs('[data-smp-edu]', root);
    if (!box || box.getAttribute('data-smp-concern-ready')) return;
    box.setAttribute('data-smp-concern-ready', '1');
    var tabs = qsa('[data-smp-concern]', box);
    if (!tabs.length) return;
    var cfg = readEduConcernConfig(box);
    function activate(tab) {
      var id = tab.getAttribute('data-smp-concern');
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.classList.toggle('is-on', on);
      });
      qsa('[data-smp-concern-panel]', box).forEach(function (p) {
        p.hidden = p.getAttribute('data-smp-concern-panel') !== id;
      });
      var title = qs('[data-smp-concern-title]', box);
      var label = tab.getAttribute('data-label') || tab.textContent.trim();
      if (title) title.textContent = label;
      var concern = (cfg && cfg.concerns && cfg.concerns[id]) || null;
      applyEduCompare(box, cfg, concern, label);
      applyEduMarkers(box, cfg, concern, label);
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activate(tab); });
    });
    var current = tabs.find(function (t) { return t.getAttribute('aria-selected') === 'true'; }) || tabs[0];
    if (current) activate(current);
  }

  function initWhyRows(root) {
    qsa('[data-smp-why-row]', root).forEach(function (row) {
      var btn = qs('[data-smp-why-toggle]', row);
      if (!btn || btn.getAttribute('data-bound')) return;
      btn.setAttribute('data-bound', '1');
      btn.addEventListener('click', function () {
        var open = row.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initSideTabs(root) {
    var box = qs('[data-smp-side]', root);
    if (!box || box.getAttribute('data-smp-side-ready')) return;
    box.setAttribute('data-smp-side-ready', '1');
    var tabs = qsa('[data-smp-side-tab]', box);
    if (!tabs.length) return;
    function activate(tab) {
      var id = tab.getAttribute('data-smp-side-tab');
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
      qsa('[data-smp-side-panel]', box).forEach(function (p) {
        p.hidden = p.getAttribute('data-smp-side-panel') !== id;
      });
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activate(tab); });
    });
    var current = tabs.find(function (t) { return t.getAttribute('aria-selected') === 'true'; }) || tabs[0];
    if (current) activate(current);
  }

  /* ---------- Pack cards <-> Kaching (safe, debounced, no body MO) ---------- */
  function readPackMap() {
    var el = qs('[data-slimmy-pack-map]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function variantIdForBottles(n) {
    var map = readPackMap();
    if (!map || !map.variants) return null;
    var found = null;
    Object.keys(map.variants).forEach(function (vid) {
      if (Number(map.variants[vid].bottles) === Number(n)) found = vid;
    });
    return found;
  }

  function isSubscribeMode() {
    var subOn = qs('.kaching-bundles__subscriptions input[type="checkbox"]:checked, .kaching-bundles__subscriptions [aria-checked="true"], .kaching-bundles__purchase-option--subscription.is-selected, .kaching-bundles__purchase-option--subscription[aria-checked="true"]');
    if (subOn) return true;
    var one = qs('.kaching-bundles__purchase-option--onetime.is-selected, .kaching-bundles__purchase-option--one-time.is-selected');
    if (one) return false;
    var sp = qs('form[action*="/cart/add"] [name="selling_plan"], [name="selling_plan"]');
    if (sp && sp.value && String(sp.value) !== '0') return true;
    return false;
  }

  function selectKachingByBottles(bottles) {
    var want = variantIdForBottles(bottles);
    var bars = qsa('.kaching-bundles__bar[data-deal-bar-id], .kaching-bundles__bar');
    if (!bars.length) return false;
    var target = null;
    if (want) {
      bars.forEach(function (bar) {
        if (target) return;
        var inp = bar.querySelector('input[name="id"], input[data-productid], [data-variant-id]');
        var vid = inp && (inp.value || inp.getAttribute('data-variant-id') || inp.getAttribute('data-productid'));
        if (vid && String(vid) === String(want)) target = bar;
        var ds = bar.getAttribute('data-variant-id') || bar.getAttribute('data-product-id');
        if (ds && String(ds) === String(want)) target = bar;
      });
    }
    if (!target) {
      var plain = bars.filter(function (b) { return !b.closest('.kaching-bundles__subscriptions'); });
      var order = { 1: 0, 3: 1, 5: 2 };
      var idx = order[Number(bottles)];
      if (typeof idx === 'number') target = plain[idx] || bars[idx];
    }
    if (!target) return false;
    var clickable = target.querySelector('label') || target.querySelector('input[type="radio"]') || target;
    try { clickable.click(); } catch (e) {}
    return true;
  }

  function syncPackCards(root) {
    var box = qs('[data-smp-packs]', root || document);
    if (!box) return;
    if (box.getAttribute('data-smp-packs-ready')) return;
    box.setAttribute('data-smp-packs-ready', '1');

    var cards = qsa('[data-smp-pack]', box);
    if (!cards.length) return;
    var otOnly = box.getAttribute('data-smp-packs-ot-only') === '1';
    var atc = qs('[data-smp-packs-atc]', box);
    var atcDaily = qs('[data-smp-packs-atc-daily]', box);

    var paintScheduled = false;
    function schedulePaint() {
      if (paintScheduled) return;
      paintScheduled = true;
      setTimeout(function () {
        paintScheduled = false;
        paint();
      }, 120);
    }

    function selectedCard() {
      return cards.find(function (c) { return c.classList.contains('is-selected') || c.getAttribute('aria-pressed') === 'true'; }) || cards[1] || cards[0];
    }

    function syncAtc(card) {
      if (!card) return;
      var daily = card.getAttribute('data-ot-daily') || '';
      if (atcDaily && daily) atcDaily.textContent = daily;
    }

    function paint() {
      /* Pick-your-pack section is ONE-TIME only (Raj). Still select Kaching bars. */
      var sub = otOnly ? false : isSubscribeMode();
      if (box.getAttribute('data-mode') !== (sub ? 'subscribe' : 'onetime')) {
        box.setAttribute('data-mode', sub ? 'subscribe' : 'onetime');
      }

      var selectedBottles = null;
      var selBar = qs('.kaching-bundles__bar--selected, .kaching-bundles__bar.is-selected, .kaching-bundles__bar[aria-checked="true"]');
      if (selBar) {
        var inp = selBar.querySelector('input[name="id"]');
        var vid = inp && inp.value;
        var map = readPackMap();
        if (vid && map && map.variants && map.variants[vid]) selectedBottles = map.variants[vid].bottles;
      }
      if (!selectedBottles) {
        var formId = qs('form[action*="/cart/add"] [name="id"], product-form [name="id"]');
        var map2 = readPackMap();
        if (formId && formId.value && map2 && map2.variants && map2.variants[formId.value]) {
          selectedBottles = map2.variants[formId.value].bottles;
        }
      }
      var userPick = box.getAttribute('data-smp-user-bottles');
      if (userPick) selectedBottles = Number(userPick);

      if (!selectedBottles) {
        var cur = selectedCard();
        if (cur) selectedBottles = Number(cur.getAttribute('data-bottles'));
      }

      cards.forEach(function (card) {
        var b = Number(card.getAttribute('data-bottles'));
        var on = selectedBottles != null && Number(selectedBottles) === b;
        var was = card.classList.contains('is-selected');
        if (on !== was) {
          card.classList.toggle('is-selected', on);
          card.setAttribute('aria-pressed', on ? 'true' : 'false');
        }
        var daily = qs('[data-smp-pack-daily]', card);
        var total = qs('[data-smp-pack-total]', card);
        var otDaily = card.getAttribute('data-ot-daily');
        var otTotal = card.getAttribute('data-ot-total');
        if (daily && otDaily) daily.textContent = otDaily;
        if (total && otTotal) total.textContent = otTotal;
      });

      var sel = cards.find(function (c) { return c.classList.contains('is-selected'); }) || selectedCard();
      syncAtc(sel);
    }

    function choose(bottles) {
      var want = Number(bottles);
      box.setAttribute('data-smp-user-bottles', String(want));
      selectKachingByBottles(want);
      cards.forEach(function (c) {
        var on = Number(c.getAttribute('data-bottles')) === want;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      syncAtc(selectedCard());
      schedulePaint();
      setTimeout(schedulePaint, 280);
      setTimeout(function () { box.removeAttribute('data-smp-user-bottles'); }, 600);
    }

    cards.forEach(function (card) {
      if (card.getAttribute('data-bound')) return;
      card.setAttribute('data-bound', '1');
      card.addEventListener('click', function () {
        choose(Number(card.getAttribute('data-bottles')));
      });
    });

    if (atc && !atc.getAttribute('data-bound')) {
      atc.setAttribute('data-bound', '1');
      atc.addEventListener('click', function () {
        if (purchaseBusy()) return;
        var sel = selectedCard();
        if (sel) choose(Number(sel.getAttribute('data-bottles')));
        /* Trigger the real PDP Kaching ATC (same form the sticky uses) */
        var real = qs('[data-slimmy-kaching-trigger], form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"], .product-form__submit, button[name="add"]');
        if (real) {
          lastProxyAt = Date.now();
          try { real.click(); } catch (_) {}
        } else {
          var offer = qs('#offers, .kaching-bundles, kaching-bundles-block');
          if (offer) {
            try { offer.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {}
          }
        }
      });
    }

    paint();

    /* CRITICAL: never observe document.body. Only the Kaching host if present. */
    var host = qs('kaching-bundles-block, .kaching-bundles');
    if (host && !host.getAttribute('data-smp-mo')) {
      host.setAttribute('data-smp-mo', '1');
      try {
        var mo = new MutationObserver(function () { schedulePaint(); });
        mo.observe(host, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['class', 'checked', 'aria-checked', 'aria-selected']
        });
      } catch (_) {}
    }

    document.addEventListener('kaching-bundles-initialized', schedulePaint);
    window.addEventListener('kaching-bundles-initialized', schedulePaint);
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.closest && (t.closest('kaching-bundles-block') || t.closest('.kaching-bundles') || t.name === 'id' || t.name === 'selling_plan')) {
        schedulePaint();
      }
    });
    var tries = 0;
    (function waitKaching() {
      tries += 1;
      if (qs('.kaching-bundles__bar') || tries > 40) {
        schedulePaint();
        return;
      }
      setTimeout(waitKaching, 250);
    })();
  }

  /* ---------- Urgency ---------- */
  function initUrgency(root) {
    var box = qs('[data-smp-urgency]', root);
    if (!box || !box.classList.contains('is-on')) return;
    if (box.getAttribute('data-smp-urgency-ready')) return;
    box.setAttribute('data-smp-urgency-ready', '1');

    var mode = box.getAttribute('data-smp-timer-mode') || 'off';
    var timerEl = qs('[data-smp-timer]', box);
    var fill = qs('[data-smp-progress-fill]', box);
    var sold = box.getAttribute('data-smp-sold');
    if (sold && !isNaN(Number(sold))) {
      var pct = Math.max(0, Math.min(100, Number(sold)));
      box.style.setProperty('--smp-sold-pct', pct + '%');
      if (fill) {
        fill.style.width = pct + '%';
        fill.style.setProperty('width', pct + '%', 'important');
      }
      var bar = qs('.smp-urgency__bar', box);
      if (bar) bar.style.setProperty('--smp-sold-pct', pct + '%');
    }
    if (!timerEl || mode === 'off') {
      if (timerEl) timerEl.hidden = true;
      return;
    }
    var minutes = parseInt(box.getAttribute('data-smp-timer-minutes') || '37', 10);
    if (isNaN(minutes) || minutes <= 0) minutes = 37;
    var endMs = null;
    /* v2 key: prior v1 kept expired ends forever → "Offer window ended" stickiness */
    var key = 'slimmy_pdp_urgency_end_v2';
    var isSession = mode === 'session30' || mode === 'session37' || mode === 'landing';
    if (mode === 'campaign') {
      var iso = box.getAttribute('data-smp-timer-end');
      endMs = iso ? Date.parse(iso) : NaN;
      if (!endMs) { timerEl.hidden = true; return; }
    } else if (isSession) {
      try {
        var stored = localStorage.getItem(key);
        if (stored && !isNaN(Number(stored)) && Number(stored) > Date.now()) {
          endMs = Number(stored);
        } else {
          /* missing OR expired → start a fresh window (urgency UI, not inventory) */
          endMs = Date.now() + minutes * 60 * 1000;
          localStorage.setItem(key, String(endMs));
        }
        try { localStorage.removeItem('slimmy_pdp_urgency_end_v1'); } catch (_) {}
      } catch (e) {
        endMs = Date.now() + minutes * 60 * 1000;
      }
    } else {
      timerEl.hidden = true;
      return;
    }
    function fmt(left) {
      var s = Math.max(0, Math.floor(left / 1000));
      var h = Math.floor(s / 3600); s %= 3600;
      var m = Math.floor(s / 60); s %= 60;
      if (h > 0) return 'Ends in ' + h + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      return 'Ends in ' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    }
    function tick() {
      var left = endMs - Date.now();
      if (left <= 0) {
        if (isSession) {
          /* Rolling session window: restart instead of locking on ended copy */
          endMs = Date.now() + minutes * 60 * 1000;
          try { localStorage.setItem(key, String(endMs)); } catch (_) {}
          timerEl.removeAttribute('data-ended');
          timerEl.textContent = fmt(endMs - Date.now());
          setTimeout(tick, 250);
          return;
        }
        timerEl.textContent = box.getAttribute('data-smp-timer-ended') || 'Offer window ended';
        timerEl.setAttribute('data-ended', 'true');
        return;
      }
      timerEl.removeAttribute('data-ended');
      timerEl.textContent = fmt(left);
      setTimeout(tick, 250);
    }
    tick();
  }


  function initInside(root) {
    var boxes = qsa('[data-smp-inside]', root);
    if (!boxes.length) return;
    boxes.forEach(function (box) {
      if (box.getAttribute('data-smp-inside-ready')) return;
      box.setAttribute('data-smp-inside-ready', '1');
      var tabs = qsa('[data-smp-inside-tab]', box);
      var nameEl = qs('[data-smp-inside-name]', box);
      var bodyEl = qs('[data-smp-inside-body]', box);
      var card = qs('[data-smp-inside-card]', box);
      if (!tabs.length || !nameEl || !bodyEl) return;
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t) {
            var on = t === tab;
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          nameEl.textContent = tab.getAttribute('data-name') || '';
          bodyEl.textContent = tab.getAttribute('data-body') || '';
          if (card) card.setAttribute('aria-labelledby', tab.id || '');
        });
      });
    });
  }

  /* ---------- Sticky ATC sync (if present) ---------- */
  function initSticky(root) {
    var sticky = qs('[data-smp-sticky], .smp-sticky', root || document);
    if (!sticky || sticky.getAttribute('data-smp-sticky-ready')) return;
    sticky.setAttribute('data-smp-sticky-ready', '1');
    var btn = qs('[data-smp-sticky-atc], .smp-sticky__btn, button', sticky);
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      var real = qs('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"], #offers button[type="submit"], .product-form__submit');
      if (real) {
        e.preventDefault();
        if (purchaseBusy()) return;
        lastProxyAt = Date.now();
        try { real.click(); } catch (_) {}
      }
    });
  }

  function boot(root) {
    root = root || document;
    initBA(root);
    initEduBA(root);
    initBots(root);
    initInside(root);
    initConcernTabs(root);
    initWhyRows(root);
    initSideTabs(root);
    syncPackCards(root);
    initUrgency(root);
    initSticky(root);
  }

  /* Guard against stacked boots / section:load re-entry without cleanup */
  function safeBoot(root) {
    try { boot(root || document); } catch (err) {
      if (typeof console !== 'undefined' && console.error) console.error('[slimmy-pdp]', err);
    }
  }

  if (document.documentElement.getAttribute('data-smp-booted') !== '1') {
    document.documentElement.setAttribute('data-smp-booted', '1');
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { safeBoot(document); });
    } else {
      safeBoot(document);
    }
    document.addEventListener('shopify:section:load', function (e) {
      /* Re-init only inside the reloaded section; ready flags prevent listener stacks */
      safeBoot(e.target || document);
    });
  }
})();
